import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import { computed, isArrayLike } from 'mobx';
import isPlainObject from 'lodash/isPlainObject';
import isNil from 'lodash/isNil';
import omit from 'lodash/omit';
import { getConfig } from '../../../lib/configure';
import { FormField } from '../field/FormField';
import autobind from '../_util/autobind';
import { BooleanValue, FieldType } from '../data-set/enum';
import ObserverCheckBox from '../check-box/CheckBox';
import { processFieldValue } from '../data-set/utils';
import isEmpty from '../_util/isEmpty';
let Output = class Output extends FormField {
    get editable() {
        return false;
    }
    useFocusedClassName() {
        return false;
    }
    handleChange() {
    }
    getOtherProps() {
        return omit(super.getOtherProps(), ['name']);
    }
    getValueKey(value) {
        if (isArrayLike(value)) {
            return value.map(this.getValueKey, this).join(',');
        }
        return this.processValue(value);
    }
    processValue(value) {
        if (!isNil(value)) {
            const text = isPlainObject(value) ? value : super.processValue(value);
            const { field, lang } = this;
            if (field) {
                return processFieldValue(text, field, lang, true);
            }
            return text;
        }
        return '';
    }
    defaultRenderer({ value, text, repeat, maxTagTextLength }) {
        const { field } = this;
        if (field && field.type === FieldType.boolean) {
            return React.createElement(ObserverCheckBox, { disabled: true, checked: value === field.get(BooleanValue.trueValue) });
        }
        const result = super.defaultRenderer({ text, repeat, maxTagTextLength });
        return isEmpty(result) ? getConfig('renderEmpty')('Output') : result;
    }
    getRenderedValue() {
        const { multiple, range, multiLine, currency } = this;
        if (multiple) {
            return this.renderMultipleValues(true);
        }
        if (range) {
            return this.renderRangeValue(true);
        }
        /**
         * 多行单元格渲染
         */
        if (multiLine) {
            return this.renderMultiLine(true);
        }
        /**
         * 货币渲染
         */
        if (currency) {
            return this.renderCurrency(true);
        }
        return this.getTextNode() === '' ? getConfig('tableDefaultRenderer') : this.getTextNode();
    }
    renderWrapper() {
        return React.createElement("span", Object.assign({}, this.getMergedProps()), this.getRenderedValue());
    }
};
Output.displayName = 'Output';
Output.defaultProps = {
    ...FormField.defaultProps,
    suffixCls: 'output',
};
__decorate([
    computed
], Output.prototype, "editable", null);
__decorate([
    autobind
], Output.prototype, "handleChange", null);
__decorate([
    autobind
], Output.prototype, "defaultRenderer", null);
Output = __decorate([
    observer
], Output);
export default Output;
